import {
  CheckCircle,
  Notepad,
  UsersFour,
  WarningCircle,
} from '@phosphor-icons/react'
import React, { useContext, useEffect, useState } from 'react'
import { ActionCard } from '../../components/ActionCard'
import { Modal } from '../../components/Modal'
import { SideTab } from '../../components/SideTab'
import { Button } from '../../components/common/Button'
import { DefaultContent } from '../../components/common/DefaultContent'
import { ContextResidents } from '../../context/context_residents'
import { FormNewResident } from './components/FormNewResident'
import { FormResidentInactive } from './components/FormResidentInactive'
import { FormUserDataResident } from './components/FormUserDataResident'
import { TableResidents } from './components/TableResidents'
import { Body, Container, Header, Title } from './styles'

import { Helmet } from 'react-helmet'

export const Residents = () => {
  const {
    editItem,
    sendUpdate,
    stopEditing,
    createResident,
    activateUser,
    disableUser,
    errorModal,
    errorMessage,
    setErrorModal,
    modalSaveNewResidentSuccess,
    setModalSaveNewResidentSuccess,
  } = useContext(ContextResidents)

  // const [tempItem, setTempItem] = useState(editItem)

  const [newResidentState, setNewResidentState] = useState(false)
  const [dataResidentState, setDataResidentState] = useState(false)
  const [inactiveResidentState, setInactiveResidentState] = useState(false)

  const [modalEnableResidentConfirm, setModalEnableResidentConfirm] =
    useState(false)

  const [modalSaveDataResident, setModalSaveDataResident] = useState(false)
  const [modalDisableResident, setModalDisableResident] = useState(false)
  const [modalResidentSuccess, setModalResidentSuccess] = useState(false)
  const [tableUpdate, setTableUpdate] = useState(false)

  const [modalSaveNewResident, setModalSaveNewResident] = useState(false)
  useState(false)

  const handlerState = (setValue) => {
    setValue((prev) => !prev)
  }

  const handlerStatedisable = (setValue) => {
    setValue((prev) => !prev)
    window.location.reload()
  }

  // const activeResident = () => {
  //   setTempItem((prev) => ({
  //     ...prev,
  //     active: true,
  //   }))
  // }

  return (
    <>
      <Helmet>
        <title>Previx - Moradores</title>
        <meta name="Previx - Moradores" content="Página de moradores" />
      </Helmet>
      <DefaultContent
        icon={<UsersFour size={26} color="#003E5F" weight="fill" />}
        title="Previx - Moradores"
      >
        <Container>
          <Header>
            <ActionCard.Root>
              <ActionCard.Content
                onclick={() => handlerState(setNewResidentState)}
                background="#52427B"
                border="#BBA7E3"
                color="#fff"
              >
                <ActionCard.Icon
                  transform={20}
                  icon={<Notepad size={60} weight="fill" color="#BBA7E3" />}
                />

                <ActionCard.Information value="Cadastrar novo Morador" />
              </ActionCard.Content>
            </ActionCard.Root>
          </Header>
          <Body>
            <Title>Lista de usuários cadastrados na plataforma</Title>
            <TableResidents
              openModalActive={setDataResidentState}
              openModalInactive={setInactiveResidentState}
              updateTable={tableUpdate}
            />
          </Body>
        </Container>

        {/* Editar dados de usuário - ATIVOS */}
        <SideTab
          open={dataResidentState}
          title="Dados do usuário"
          toggleFunction={() => handlerState(setDataResidentState)}
          width="45%"
        >
          <FormUserDataResident
            handleModalDisable={setModalDisableResident}
            handleModalSave={setModalSaveDataResident}
            // handleDataResidentState={setDataResidentState}
          />
        </SideTab>

        {/* salvar */}

        {/* desativar */}
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="25%"
          height="fit-content"
          left="50%"
          top="50%"
          open={modalDisableResident}
          setIsOpenController={() => {
            handlerState(setModalDisableResident)
          }}
          padding="0 1rem 1rem"
        >
          <Modal.Header
            onclick={() => {
              handlerState(setModalDisableResident)
            }}
          />
          <Modal.Content
            value="Você deseja realmente desativar?"
            subvalue="Ao clicar em salvar, você estará desativando o acesso desse grupo de usuários."
          />
          <Modal.Footer>
            <Button.Root
              backgroundColor="#fff"
              border="1px solid #770A00"
              onClick={() => {
                stopEditing()
                handlerState(setModalDisableResident)
              }}
            >
              <Button.Content title="Não, cancelar" color="#770A00" />
            </Button.Root>
            <Button.Root
              backgroundColor="#770A00"
              onClick={() => {
                disableUser()
                handlerStatedisable(setModalDisableResident)
                handlerState(setModalResidentSuccess)
              }}
            >
              <Button.Content title="DESATIVAR" color="#fff" />
            </Button.Root>
          </Modal.Footer>
        </Modal.Root>

        {/* sucesso */}
        {/* <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="fit-content"
          height="fit-content"
          left="50%"
          top="50%"
          open={modalResidentSuccess}
          setIsOpenController={() => {
            handlerState(setModalResidentSuccess)
          }}
          padding="0 1rem 1rem"
        >
          <Modal.Header
            onclick={() => {
              handlerState(setModalResidentSuccess)
            }}
          />
          <Modal.Icon icon={<CheckCircle size={48} fill="#006598" />} />
          <Modal.Content
            value="Dados atualizados!"
            subvalue="O perfil desse usuário foi atualizado."
          />
          <Modal.Footer>
            <Button.Root
              backgroundColor="#00517D"
              onClick={() => {
                handlerState(setModalResidentSuccess)
                handlerState(setDataResidentState)
                window.location.reload()
              }}
            >
              <Button.Content title="OK" color="#fff" />
            </Button.Root>
          </Modal.Footer>
        </Modal.Root> */}

        {/* Cadastro morador */}
        <SideTab
          open={newResidentState}
          title="Cadastro de morador"
          toggleFunction={() => handlerState(setNewResidentState)}
          width="45%"
        >
          <FormNewResident handleModal={setModalSaveNewResident} />
        </SideTab>

        {/* cadastrar confirmar */}
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="25%"
          height="fit-content"
          left="50%"
          top="50%"
          open={modalSaveNewResident}
          setIsOpenController={() => {
            handlerState(setModalSaveNewResident)
          }}
          padding="0 1rem 1rem"
        >
          <Modal.Header
            onclick={() => {
              handlerState(setModalSaveNewResident)
            }}
          />
          <Modal.Content
            value="Você deseja salvar?"
            subvalue="Ao clicar em salvar, você estará atualizando este contrato no sistema."
          />
          <Modal.Footer>
            <Button.Root
              backgroundColor="#fff"
              border="1px solid #770A00"
              onClick={() => {
                stopEditing()
                handlerState(setModalSaveNewResident)
              }}
            >
              <Button.Content title="Não, cancelar" color="#770A00" />
            </Button.Root>
            <Button.Root
              backgroundColor="#067FB7"
              onClick={() => {
                handlerState(setModalSaveNewResident)
                createResident()
              }}
            >
              <Button.Content title="SALVAR" color="#fff" />
            </Button.Root>
          </Modal.Footer>
        </Modal.Root>

        {/* cadastro sucesso */}
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="30%"
          height="fit-content"
          left="50%"
          top="50%"
          open={modalSaveNewResidentSuccess}
          setIsOpenController={() => {
            handlerState(setModalSaveNewResidentSuccess)
            location.reload()
          }}
          padding="0 1rem 1rem"
        >
          <Modal.Header
            onclick={() => {
              handlerState(setModalSaveNewResidentSuccess)
              location.reload()
            }}
          />
          <Modal.Icon icon={<CheckCircle size={48} fill="#006598" />} />
          <Modal.Content
            value="Usuário cadastrado!"
            subvalue="Pegue o usuário de acesso e sua senha e encaminhe para o usuário que acessará e usará o sistema. Os dados serão encaminhados via e-mail também."
          />
          <Modal.Footer>
            <Button.Root
              backgroundColor="#00517D"
              onClick={() => {
                handlerState(setModalSaveNewResidentSuccess)
                handlerState(setNewResidentState)
                location.reload()
              }}
            >
              <Button.Content title="Voltar para página" color="#fff" />
            </Button.Root>
          </Modal.Footer>
        </Modal.Root>

        {/* Editar dados de usuário - INATIVOS */}
        <SideTab
          open={inactiveResidentState}
          title="Dados do usuário"
          toggleFunction={() => handlerState(setInactiveResidentState)}
          width="45%"
        >
          <FormResidentInactive
            handleModalEnable={setModalEnableResidentConfirm}
          />
        </SideTab>

        {/* reativar confirmar */}
        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="25%"
          height="fit-content"
          left="50%"
          top="50%"
          open={modalEnableResidentConfirm}
          setIsOpenController={() => {
            handlerState(setModalEnableResidentConfirm)
          }}
          padding="0 1rem 1rem"
        >
          <Modal.Header
            onclick={() => {
              handlerState(setModalEnableResidentConfirm)
            }}
          />
          <Modal.Content
            value="Você deseja realmente reativar?"
            subvalue="Ao clicar em salvar, você estará reativando o acesso desse grupo de usuários."
          />
          <Modal.Footer>
            <Button.Root
              backgroundColor="#fff"
              border="1px solid #770A00"
              onClick={() => {
                stopEditing()
                handlerState(setModalEnableResidentConfirm)
              }}
            >
              <Button.Content title="Não, cancelar" color="#770A00" />
            </Button.Root>
            <Button.Root
              backgroundColor="#067FB7"
              onClick={() => {
                handlerState(setModalResidentSuccess)
                sendUpdate()
                handlerState(setModalEnableResidentConfirm)
                handlerState(setTableUpdate)
                location.reload()
              }}
            >
              <Button.Content title="SALVAR" color="#fff" />
            </Button.Root>
          </Modal.Footer>
        </Modal.Root>

        <Modal.Root
          backgroundcolor="#fff"
          borderradius="6px"
          width="30%"
          height="fit-content"
          left="50%"
          top="50%"
          open={errorModal}
          setIsOpenController={() => {
            setErrorModal(false)
          }}
        >
          <Modal.Icon
            icon={<WarningCircle size={48} weight="fill" fill="#BB0000" />}
          />
          <Modal.Content
            value="Erro ao criar usuário"
            subvalue={errorMessage}
          />
        </Modal.Root>
      </DefaultContent>
    </>
  )
}
